// languagePersistence.ts
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "@/types/Languages.types";

const LANGUAGE_KEY = "preferredLanguage";

export function getSavedLanguage(): SupportedLanguage | null {
  const saved = localStorage.getItem(LANGUAGE_KEY);
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(saved ?? "") ? (saved as SupportedLanguage) : null;
}

export function saveLanguage(lang: string) {
  // Updated validation to allow 'en-us', 'zh-hant', 'zh-hans'
  if ((SUPPORTED_LANGUAGES as readonly string[]).includes(lang)) {
    localStorage.setItem(LANGUAGE_KEY, lang);
  }
}

export function removeSavedLanguage() {
  localStorage.removeItem(LANGUAGE_KEY);
}
